import { render, staticRenderFns } from "./addLicense.vue?vue&type=template&id=5bad2902"
import script from "./addLicense.vue?vue&type=script&lang=js"
export * from "./addLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports